import styled from "styled-components";

const HeaderContainer = styled.header`
  width: 100vw;
  height: 3.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export { HeaderContainer };
